const hasValue = value =>
  value !== undefined && value !== null && String(value).trim() !== ''

const firstValue = (...values) => values.find(hasValue) ?? ''

const pickCompany = source =>
  firstValue(
    source?.company,
    source?.companyName,
    source?.businessName,
    source?.name,
  )

const pickFirstName = source =>
  firstValue(source?.firstName, source?.recurlyFirst)

const pickLastName = source => firstValue(source?.lastName, source?.recurlyLast)

const pickLocationName = source =>
  firstValue(source?.locationName, source?.location_name)

const pickAccountCode = source =>
  firstValue(source?.accountCode, source?.thryvId, source?.code, source?.id)

const pickBillTo = source =>
  firstValue(source?.billTo, source?.billingMode, source?.bill_to)

export const normalizeBillToLabel = billTo => {
  const normalized = String(billTo || '')
    .trim()
    .toLowerCase()

  if (['parent', 'parent-pay', 'parent pay'].includes(normalized)) {
    return 'Parent Pay'
  }

  if (['self', 'child', 'self-pay', 'self pay'].includes(normalized)) {
    return 'Self Pay'
  }

  return billTo || ''
}

export const buildKP11CustomerInfo = ({
  accountInfoWithSub = {},
  thryvAccount = {},
} = {}) => {
  const subDetails = accountInfoWithSub?.subDetails || {}
  const accountInformation = accountInfoWithSub?.accountInformation || {}
  const childCustomerInfo = accountInfoWithSub?.childCustomerInfo || {}
  const subscriptionAccount = subDetails?.subscriptions?.[0]?.account || {}
  const childSubscriptionAccount =
    subDetails?.childSubscriptions?.[0]?.account || {}
  const thryvAccountInfo = thryvAccount?.accountInfo || {}
  const recurlyAccount = thryvAccount?.recurlyAccount || {}
  const routeThryvDetail = accountInfoWithSub?.thryvDetail || {}

  const sources = [
    childCustomerInfo,
    accountInformation,
    subDetails,
    childSubscriptionAccount,
    subscriptionAccount,
    thryvAccountInfo,
    recurlyAccount,
    accountInfoWithSub,
  ]

  const billTo = firstValue(...sources.map(pickBillTo))
  const firstName = firstValue(...sources.map(pickFirstName))
  const lastName = firstValue(...sources.map(pickLastName))
  const locationName = firstValue(...sources.map(pickLocationName))
  const fullName = [firstName, lastName].filter(Boolean).join(' ')

  return {
    company: firstValue(...sources.map(pickCompany)),
    firstName,
    lastName,
    locationName,
    displayName: locationName || fullName,
    accountCode: firstValue(
      childCustomerInfo?.accountCode,
      accountInfoWithSub?.accountCode,
      accountInfoWithSub?.thryvId,
      routeThryvDetail?.thryvId,
      ...sources.map(pickAccountCode),
    ),
    billTo,
    billToLabel: normalizeBillToLabel(billTo),
  }
}
